// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__c58SR","tableContainer":"Table_tableContainer__-wQwt","table":"Table_table__Pj1Ln","paginationWrapper":"Table_paginationWrapper__Fftx8"};